import { Component, Inject } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { InsightsService } from "../service/insights.service";
import {InsightApiService} from '../service/insight-api.service';
import { ReportService } from 'src/app/repository/service/report.service';
import { NotifierService } from 'angular-notifier';
@Component({
    selector:"app-delete-pop",
    templateUrl:"./delete-pop.html",
    styleUrls:['./delete-pop.css']
})
export class DeletePopComponent{
    public Delete_uuid:string = null;
    public deleteText: string;
    constructor (
        public dialoge:MatDialog,
        public iService:InsightsService,
        public apiService:InsightApiService,
        public reportService:ReportService,
        public notifier: NotifierService,
        @Inject(MAT_DIALOG_DATA) public data:any
        ) {
            if(data['vocData']['uuid'])
            {
                this.Delete_uuid = data['vocData']['uuid'];
            }

        }

    ngOnInit(){
        if(this.data['type'] == 'club') {
            this.deleteText = 'Are you sure want to delete Clubbed VOC?'
        }
        else {
            if(this.iService.isVocFileDelete){
                this.deleteText = 'Are you sure want to delete this VOC?';
            } else {
                this.deleteText = 'Are you sure want to delete Details?';
            }
        }

    }
    CloseDialoge = () =>
    {
        this.iService.isVocFileDelete = false;
        this.Delete_uuid = null;
        this.dialoge.closeAll();
    }
    DeleteDetails = () =>
    {
        if(this.iService.isVocFileDelete)
        {
            //console.log(this.iService.isVocFileDelete,'If');
            if(this.data['type'] == 'club') {
                this.clubVocDelete(this.Delete_uuid);
            }
            else{
                let body = {uuid:this.Delete_uuid}
                this.apiService.deleteVocClip(body).subscribe((result) =>
                {
                    //console.log(result,'fILE dELETED')
                    if(result.status === 1)
                    {
                        this.reportService.getVocList();
                        this.notifier.notify('success','VOC Deleted Successfully');
                    }
                    else
                    {
                        this.reportService.getVocList();
                        this.notifier.notify('error',result.message);
                    }
    
                    
                },(err) =>
                {
                    this.notifier.notify('error','An Error Occurred');
                    //console.log(err,'error');
                })
            }
            this.iService.isVocFileDelete = false;
        }
        else
        {
            //console.log(this.iService.isVocFileDelete,'else');
            this.iService.isvocEdit = false;
            this.iService.isvocadd = true;
            this.iService.vocIntroFormtitle = "";
            this.iService.vocIntroFormSubtitle = [{value:""}]
            this.notifier.notify('success','Intro Screen Details Deleted Successfully');
        }
        this.dialoge.closeAll()
        
    }

    clubVocDelete(uuid) {
        const data = {status:-1,uuid:uuid};
        this.apiService.deleteClubVoc(data).subscribe((result) => {
            if(result['status'] == 1){
                this.notifier.notify('success','Clubbed VOC deleted successfully');
                this.reportService.getRepositoryDetail(this.iService.uuid);
            }
            else{
            this.notifier.notify('error','Something went wrong');
            }
        })
    }
}